import React from 'react';
import css from './ListingsTable.module.css';
import { capitalizeFirstLetter } from '../../../util/genericHelpers';
import { formatMoney } from '../../../util/currency';
import { SecondaryButton } from '../../../components';
import { FormattedMessage } from 'react-intl';

const TableRow = ({
  id,
  title,
  imageUrl,
  price,
  state,
  createdAt,
  currentStock,
  handleSelectItem,
  intl,
  selectedItems,
  navigateToEditListingPage,
  navigateToCopyListingPage,
  listing,
  copyListingId,
}) => {
  const formattedPrice = price?.amount && formatMoney(intl, price);

  const handleRowClick = e => {
    // Don't navigate if clicking on checkbox or button
    if (e.target.closest('input[type="checkbox"]') || e.target.closest('button')) {
      return;
    }
    navigateToEditListingPage(id?.uuid, title);
  };

  return (
    <tr key={id.uuid} onClick={handleRowClick} className={css.clickableRow}>
      <td onClick={e => e.stopPropagation()}>
        <div className={css.checkboxCell}>
          <input
            type="checkbox"
            checked={selectedItems.includes(id.uuid)}
            onChange={() => handleSelectItem(id.uuid)}
            className={css.checkbox}
          />
        </div>
      </td>
      <td>
        <div className={css.cellImage}>
          <img src={imageUrl} alt={title || 'Listing Image'} className={css.listingImg} />
        </div>
      </td>
      <td>{capitalizeFirstLetter(title) || 'No Title'}</td>
      <td>{formattedPrice}</td>
      <td>{capitalizeFirstLetter(state)}</td>
      <td>{new Date(createdAt).toLocaleDateString()}</td>
      <td>{currentStock?.attributes?.quantity || 'N/A'}</td>
      <td onClick={e => e.stopPropagation()}>
        <SecondaryButton
          type="button"
          onClick={() => navigateToCopyListingPage(listing)}
          inProgress={copyListingId === id.uuid}
          disabled={copyListingId === id.uuid}
        >
          <FormattedMessage id="ShopSettingsForm.copyButton" />
        </SecondaryButton>
      </td>
    </tr>
  );
};

export default TableRow;
